<template>
   <div>
	    <div class="demo-upload-list" v-for="item in uploadList">
	       <template v-if="item.status === 'finished'">
	           <img :src="item.url">
	           <div class="demo-upload-list-cover">
	               <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
	               <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
	           </div>
	       </template>
	       <template v-else>
	           <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
	       </template>
	   </div>
	   <Upload
	       ref="upload"
	       :show-upload-list="false"
	       :default-file-list="defaultList"
	       :on-success="handleSuccess"
	       :format="['jpg','jpeg','png']"
	       :max-size="500"
	       :on-format-error="handleFormatError"
	       :on-exceeded-size="handleMaxSize"
	       :before-upload="handleBeforeUpload"
	       multiple
	       type="drag"
	       :action="url"
		   :data='data'
	       style="display: inline-block;width:58px;">
	       <div style="width: 58px;height:58px;line-height: 58px;">
	           <Icon type="ios-camera" size="20"></Icon>
	       </div>
	   </Upload>
	   <Modal title="View Image" v-model="visible">
	       <img :src="imgName" v-if="visible" style="width: 100%">
	   </Modal>
   </div>
</template>
<script>
    export default {
        data () {
            return {
                defaultList: [//上传的图片
                  /*  {
                        'name': 'a42bdcc1178e62b4694c830f028db5c0',
                        'url': 'https://o5wwk8baw.qnssl.com/a42bdcc1178e62b4694c830f028db5c0/avatar'
                    } */
                ],
                imgName: '',
                visible: false,
                uploadList: []
            }

        },
		props:["number","url","data"],
        methods: {
            handleView (name) {
                this.imgName = name;
                this.visible = true;
				//this.ret();
            },
            handleRemove (file) {
                const fileList = this.$refs.upload.fileList;
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				//this.ret();
            },
            handleSuccess (res, file) {//上传成功的返回
                file.url = res.url;
                file.name = res.name;
				this.ret();
            },
            handleFormatError (file) {//文件格式验证失败时的钩子，返回字段为 file, fileList
                this.$Notice.warning({
                    title: 'The file format is incorrect',
                    desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
                });
            },
            handleMaxSize (file) {//文件超出指定大小限制时的钩子，返回字段为 file, fileList
                this.$Notice.warning({
                    title: '图片太大',
                    desc: '图片最大不能超过 500KB.'
                });
            },
            handleBeforeUpload () {//上传文件之前的钩子，参数为上传的文件，若返回 false 或者 Promise 则停止上传
			    let n=this.number
                const check = this.uploadList.length < n;
                if (!check) {
                    this.$Notice.warning({
                        title: '最多上传'+n+'张图片'
                    });
                }
                return check;
            },
			ret(){
				let t=this
				let urls=""
				for (let i = 0; i < t.uploadList.length; i++) {
					let item=t.uploadList[i]
					console.log(item)
					urls+=item.response.name+";"
				}
				console.log(urls)
				//向父组件传值
				this.$emit('imgFile',urls);
			}
        },
        mounted () {
            this.uploadList = this.$refs.upload.fileList;
        }
    }
</script>
<style>
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>



// WEBPACK FOOTER //
// src/components/comm/imgs.vue